<fw-dialog width="extra-small">
  <fw-dialog-header>
    <h3>Create New Project</h3>
  </fw-dialog-header>

  <fw-dialog-content >
    <form class="create-project-form form-full-width">
      <fw-wrapped-input title="Select a Group">
        <fw-select width="100%" [maxOptionsHeight]="'300px'" [formControl]="groupPicker" test-id="create-project-group-select">
          @for (group of groupsWithAccess$ | async; track group._id) {
            <fw-menu-item [title]="group.label || group._id" [value]="group._id"/>
          }

        </fw-select>
      </fw-wrapped-input>

      <fw-wrapped-input title="Name Project" [errorText]="generateProjectLabel()">
        <fw-text-input [formControl]="projectsLabel" test-id="create-project-name-input"/>
      </fw-wrapped-input>
    </form>
  </fw-dialog-content>

  <fw-dialog-actions>
    <fw-button variant="outline" (click)="dialogRef.close()" test-id="project-close-button">
      Cancel
    </fw-button>
    <fw-button (click)="submit()" [disabled]="!groupPicker.valid || !projectsLabel.valid" test-id="project-create-button">
      Create
    </fw-button>
  </fw-dialog-actions>
</fw-dialog>
